import { PriceRange, Order as TypedOrder } from 'types'

export interface Order extends Omit<
  TypedOrder,
  'salesRepresentative' | 'retailer' | 'paymentMethod' | 'deliveryWindow'
> {
  collectionNames: string[]
  brandName: string
  currencyCode: string
  taxAmount: number
  lineItems: {
    discountedPrice: number
    totalUnits: number
    totalPrice: number
    totalRetailPrice: number
  } | null
  discountAmount: number
  discountedTotalRange?: PriceRange
  grandTotal?: PriceRange
  deliveryWindow: string
  shippingAddress: string[]
  billingAddress: string[]
  shippingPhone: string
  billingPhone: string
  shippingEmail: string
  salesRepresentative?: {
    id: string
    name: string
    email: string
  }
  shippingPrice: number
  seasonYear?: {
    year: string
    season: {
      name: string
    }
  }
  door?: {
    name: string
  }
  warehouse?: {
    name: string
  }
  paymentMethod?: {
    paymentName: string
  }
  billingCountry: string
  destinationAccountId?: string
  retailer?: {
    id: string
    displayName: string
  }
  partialPaymentRequests?: {
    id: string
    currency: string
    name: string
    amount: string
    active: boolean
  }
}

/**
 * TODO: Refund Error is not currently in the atlas types. Because of that
 * we have to use our own enum for now. In the future we should go back to
 * use the generated enum from atlas either because REFUND_ERROR was added
 * to atlas or because we decide to not use nor consider REFUND_ERROR on
 * our display logic.
 *  */
export enum PaymentRecordStatus {
  SUCCESS = 'Success',
  PAID = 'Paid',
  REFUND = 'Refunded',
  ERROR = 'Failed',
  PROCESSING = 'Processing',
  REFUND_PROCESSING = 'Refund Processing',
  REFUND_ERROR = 'RefundError',
  PENDING = 'Pending',
}
export interface PaymentData {
  total: number
  localTotal: number
  payments: Payment[]
}

export type Payment = {
  id: string
  date: Date
  amount: number
  localAmount: number
  localCurrency: string
  currencyCode: string
  methodName: string
  status: PaymentRecordStatus
  externalIdentifier?: string
  errorMessage?: string
}

export interface BillingAddressDictionary {
  name: string
  email: string
  street: string
  city: string
  country: string
  state: string
  zip: string
}

export interface RateOffer {
  Id: string
  Currency: string
  Expiry: Date
  Rate: number
}

interface RateOffers {
  RateOffers: RateOffer[]
}

export interface GetRatesQuery {
  rates: RateOffers
}

export interface GetRatesQueryVariables {
  merchantId: string
}

export type TransformedPaymentRecords = {
  id: string
  amount: number
  date: string
  status: string
  currencyCode: string
  last4: string
  billingName: string
  billingEmail: string
  type: string
  methodName: string
  localAmount?: number
  localCurrency?: string
  externalIdentifier: string
  errorMessage?: string
}
